import { IApplicationState, TCardId } from '../../../types/types';
import { getCardChecklists } from '../checklists/checklists/selectors/getCardChecklists';

export const getCardEpicChecklistsDueDate = (
    state: IApplicationState,
    cardId: TCardId,
): number => {
    const checklists = getCardChecklists(state, cardId);
    let checkListDueDate = 0;

    for (let checklist in checklists) {
        let checkitems = checklists[checklist].checkItems ? Object.values(checklists[checklist].checkItems) : null;
        if (checkitems && checkitems.length) {
            checkitems.forEach((item => {
                if (item && item.dueDate && checkListDueDate < item.dueDate) {
                    checkListDueDate = item.dueDate
                }
            }))
        }
    }
    return checkListDueDate;
}
